<ng-container *ngIf="initialized">

    <div class="grid">
        <div class="col-12 pt-0">

            <!-- Inline artefacts section — mirrors the "Artefakte" widget heading style -->
            <div *ngIf="inlineArtefacts && inlineArtefacts.length > 0" class="mt-3 p-3">
                <div class="font-bold mb-3">Inline Artefakte</div>
                <div class="surface-card border-round border-1 surface-border">
                    <div *ngFor="let artefact of inlineArtefacts; let last = last"
                         class="flex align-items-center gap-3 px-3 py-2 cursor-pointer te-inline-artefact-row"
                         [class.border-bottom-1]="!last"
                         [class.surface-border]="!last">
                        <i class="fa-regular fa-puzzle-piece text-primary"></i>
                        <span class="flex-1">{{ artefact['artefactDtoName'] || 'Artefakt #' + artefact['artefactDtoId'] }}</span>
                        <p-button icon="fa-regular fa-arrow-right-to-bracket"
                                  pTooltip="In Template einfügen" tooltipPosition="left"
                                  styleClass="p-button-text p-button-sm"
                                  (click)="handleInsertArtefactInline(artefact)"></p-button>
                    </div>
                </div>
            </div>

            <mvs-widget
                    *ngIf="widgetTemplateArtefacts"
                    [widgetData]="widgetTemplateArtefacts"
                    (onObjectSelect)="handleSelectArtefact($event)"
                    (onChangedObject)="refreshTemplateArtefactsForInline()"
                    [importObjectContext]="importContextTemplate"
            ></mvs-widget>

            <mvs-widget
                    *ngIf="widgetTemplateArtefactVariableLink"
                    [widgetData]="widgetTemplateArtefactVariableLink"
                    [importObjectContext]="importContextArtefact"
            ></mvs-widget>

        </div>
    </div>

</ng-container>


<p-dialog header="Artefakt hinzufügen" [(visible)]="visible" [style]="{width: '50vw'}">

    <div class="grid">
        <div class="col-12">

            <h5 class="text-sm">Artefakt-Auswahl</h5>
        </div>
        <div class="col-12">

            <!-- dropdown to select artefact -->
<!--            <p-select-->
<!--                    *ngIf="artefactsList && artefactsList.entries"-->
<!--                    [style]="{'min-width': '180px'}"-->
<!--                    [options]="artefactsList.entries"-->
<!--                    placeholder="Artefakt auswählen"-->
<!--                    panelStyleClass="text-sm artefact"-->
<!--                    [(ngModel)]="selectedArtefact"-->
<!--                    optionLabel="name"-->
<!--                    appendTo="body"-->
<!--            ></p-select>-->
        </div>

        <div class="col-12">

            <p-selectButton [options]="artefactLocation" [(ngModel)]="selectedLocation" optionLabel="icon"
                            optionValue="value">
                <ng-template #item let-item>
                    <i [class]="item.icon"></i>
                </ng-template>
            </p-selectButton>

        </div>

        <div class="col-12">
            <!-- input to enter artefact priority -->
            <p-inputNumber
                    [(ngModel)]="selectedPriority"
                    placeholder="Priorität eingeben"
            ></p-inputNumber>
        </div>

        <div class="col-12">
            <p-button
                    label="Übernehmen"
                    (click)="createTemplateArtefact()"
                    [disabled]="busy"
            ></p-button>
        </div>
    </div>

</p-dialog>